import Marquee from "react-fast-marquee";
import { PRESS_LOGOS, PARTNERS } from "../lib/content";

// Single thin running marquee — no headers, no NDA stamp, fast travel.
export default function LogoMarquee({ variant = "press", direction = "left" }) {
  const items = variant === "partners" ? PARTNERS : PRESS_LOGOS;
  const isOnDark = variant === "press";

  const wrap = isOnDark
    ? "bg-ink text-cream border-y border-cream/15"
    : "bg-cream text-ink border-y border-ink/20";

  return (
    <section className={`${wrap} overflow-hidden`} data-testid={`logo-marquee-${variant}`}>
      <div className="py-7 md:py-9">
        <Marquee gradient={false} speed={70} pauseOnHover={false} loop={0} autoFill direction={direction}>
          {items.map((name, i) => (
            <LogoChip key={i} name={name} dark={isOnDark} serif={i % 3 === 1} />
          ))}
        </Marquee>
      </div>
    </section>
  );
}

function LogoChip({ name, dark, serif }) {
  const cls = serif ? "font-serif italic font-light text-2xl md:text-4xl" : "font-display uppercase text-2xl md:text-4xl tracking-wide";
  return (
    <span
      className={`mx-8 inline-flex items-center ${cls}`}
      style={{ color: dark ? "#F3F0E9" : "#1C1C1E", letterSpacing: serif ? "-0.01em" : "0.02em" }}
    >
      {name}
      <span className={`mx-7 inline-block ${dark ? "text-cream/30" : "text-ink/30"}`} style={{ fontSize: 12 }}>✦</span>
    </span>
  );
}
